
  var _styles = {
  "comprehensive-card-title-container": {
    "width": "5.89333rem"
  },
  "comprehensive-card-title-style": {
    "width": "5.89333rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.42667rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.58667rem"
  }
};



  module.exports = _styles;
  